import Page from './Page'

export default abstract class PaginationState<I> {
  protected tokens: string[] = ['']
  protected currentPage: Page<I> = new Page()
  public readonly search: string = ''
  public readonly pageSize: number = 0

  constructor (pageSize: number, search: string) {
    this.pageSize = pageSize
    this.search = search
  }

  getCurrentPage (): Page<I> {
    return this.currentPage
  }

  async asyncChangeCurrentPage (number: number) {
    const requestedToken = this.tokens[number - 1]
    // se non esiste dare eccezione
    const [newPage, nextToken] = await this.asyncRequestPage(requestedToken)
    newPage.number = number
    if (newPage.items && newPage.items.length !== 0) {
      this.currentPage = newPage
      const nextPageIndex = newPage.number
      this.tokens.splice(nextPageIndex, 1, nextToken)
    } else {
      this.tokens[newPage.number - 1] = ''
    }
  }

  hasNextPage (): boolean {
    return this.tokens[this.currentPage.number] !== ''
  }

  abstract asyncRequestPage(token: string): Promise<[Page<I>, string]>

  abstract clone(): PaginationState<I>
}
